import mapLLMValues from './mapLLMValues';

const keys = ['model', 'temperature', 'generation', 'tools', 'toolsChoice', 'inputSchema', 'jsonMode', 'outputSchema', 'memoryRetrieverIds'];

export default function toTestConfig(config: object = {}) {
    const values = mapLLMValues({ ...config });
    return Object.fromEntries(keys
        .filter((key) => values[key] !== undefined)
        .map((key) => [key, values[key]]));
}
